/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react';
import { Container } from './styles';
import { Table } from '@gerdau/hefesto-mais-web';
import { Title, Toast } from '@gerdau/hefesto';
import { CustomTableCell } from '../../../../../components/Commons/Tables/styles';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { usePurchaseForHistoricService } from '../../../../../services/MVP/usePurchaseForHistoricService';
import { ApplicationState } from '../../../../../store';

import { useHistory, useLocation } from 'react-router-dom';
import { ERoutes } from '../../../../../routes';
import { EPurchaseRoutes } from '../../../purchase.routes';
import { EOrderSettingsRoutes } from '../orderSettings.routes';
import LoadingModal from '../../../../../components/LoadingModal';
import { sendTagging } from '../../../../../store/ducks/tagging/actions';
import BottomActionBar from '../../../../../components/BottomActionBar';
import { addToast } from '../../../../../store/ducks/toast/actions';
import { EToastTypes } from '../../../../../store/ducks/toast/types';
import { useCartService } from '../../../../../services/MVP/useCartService';
import { useProductForCustomer } from '../../../../../services/MVP/useProductForCustomer';
import { ICustomer } from '../../../../../store/ducks/customers/types';
import { ECodeType } from '../../../../../store/ducks/user/types';
import { UnavailableProductsModal } from './UnavailableProducts.Modal';
import { cleanShoppingCart } from '../../../../../store/ducks/long-steel-shopping-cart/actions';
import { BlockedModal } from '../../../../../components/Purchase/BlockedModal';
import { ITaggingParams } from '../../../../../store/ducks/tagging/types';
import { transformMeasureUnit } from '../../../../../utils/measureUnit';
import { getTaggingInformationScreen } from '../../../../../utils/Tagging';
import { ILastOrder } from '../../../../../store/ducks/long-steel-order-item-search/types';

export interface ILastOrderTableDataSource {
  key: number;
  invoiceNumber: string;
  invoiceSale: string;
  quantityProduct: number;
  invoiceDate: string;
  items: any[];
  originalDate: string;
}

export interface LastOrderItem {
  salesOrderItem: string;
  customerPurchaseItemOrder: string;
  division: string;
  divisionDescription: string;
  product: string;
  productDescription: string;
  customerProduct: string;
  paymentTerms: string;
  paymentTermsDescription: string;
  requestedQuantity: number;
  requestedMeasureUnit: string;
}

export interface LastOrder {
  customerSoldTo: string;
  customerShipTo: string;
  salesOrder: string;
  orderDate: string;
  customerPurchaseOrder: string;
  items: LastOrderItem[];
}

interface Item {
  salesOrderItem: string;
  customerPurchaseItemOrder: string;
  division: string;
  divisionDescription: string;
  product: string;
  productDescription: string;
  customerProduct: string;
  paymentTerms: string;
  paymentTermsDescription: string;
  requestedQuantity: number;
  requestedMeasureUnit: string;
  destination: string;
  price: number;
}

type ConfiguredProduct = {
  sku: string;
  qty: number;
  quote_id: string | number | undefined;
  price: string | number;
  extension_attributes: {
    measure_unity_gerdau: string;
    destination_gerdau: string;
    payment_type_gerdau: string;
    has_agreed_price_gerdau: boolean;
    sap_fields: {
      o_header_sap: [];
      o_item_sap: [];
      o_price_sap: [];
    };
  };
} | null;

const columns = [
  {
    title: 'Identificação do pedido',
    dataIndex: 'invoiceNumber',
    width: '17.375rem',
    render: (invoiceNumber: string) => (
      <CustomTableCell>{invoiceNumber}</CustomTableCell>
    )
  },
  {
    title: 'Número da ordem de venda',
    dataIndex: 'invoiceSale',
    width: '17.375rem',
    sorter: (a: ILastOrderTableDataSource, b: ILastOrderTableDataSource) =>
      Number(a.invoiceSale) - Number(b.invoiceSale),
    render: (invoiceSale: string) => (
      <CustomTableCell>{invoiceSale}</CustomTableCell>
    )
  },
  {
    title: 'Quantidade de produtos',
    dataIndex: 'quantityProduct',
    width: '17.375rem',
    render: (quantityProduct: string) => (
      <CustomTableCell>{quantityProduct}</CustomTableCell>
    )
  },
  {
    title: 'Data do pedido',
    dataIndex: 'invoiceDate',
    width: '17.375rem',
    sorter: (a: ILastOrderTableDataSource, b: ILastOrderTableDataSource) =>
      a.originalDate.localeCompare(b.originalDate),
    render: (invoiceDate: string) => (
      <CustomTableCell>{invoiceDate}</CustomTableCell>
    )
  }
];

interface LastOrderListProps {
  getCustomer: () => ICustomer;
}

const LastOrderList = ({ getCustomer }: LastOrderListProps) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const { pathname } = useLocation();
  const { commerceScreenName } = getTaggingInformationScreen(pathname);

  const emitterId = useSelector(
    (state: ApplicationState) => state.longSteelShoppingCart
  ).emitterId;

  const { customers } = useSelector(
    (state: ApplicationState) => state.customers
  );
  const customersState = useSelector(
    (appState: ApplicationState) => appState.customers
  );
  const lastOrdersState = useSelector(
    (state: ApplicationState) => state.longSteelOrderItemSearch.lastOrdersState
  );
  const cartQuantity = useSelector(
    (state: ApplicationState) => state.cartItemsMvp.quantity
  );
  const selectedCustomer = customers.find((c) => c.customerId === emitterId);
  const isBlockedCustomer =
    selectedCustomer?.blocks &&
    selectedCustomer?.blocks?.filter((blc) => blc.type === 'order')?.length > 0;
  const [openBlockedModal, setOpenBlockedModal] = useState(isBlockedCustomer);
  const onCloseBlockedModal = () => {
    dispatch(cleanShoppingCart());
    setOpenBlockedModal(false);
  };
  useEffect(() => {
    setOpenBlockedModal(isBlockedCustomer);
  }, [selectedCustomer]);

  const { getPurchaseHistoric } = usePurchaseForHistoricService();

  const { getCartId, getCartItemQuantity, addBulkCartItem } = useCartService();
  const { getMultProducts } = useProductForCustomer();

  const [selectedOrderItem, setSelectedOrderItem] = useState<
    ILastOrderTableDataSource | undefined
  >();

  const [lastOrdersItems, setLastOrdersItems] = useState<
    ILastOrderTableDataSource[]
  >([]);

  const [unavailableProducts, setUnavailableProducts] = useState<string[]>([]);
  const [configuredProducts, setConfiguredProducts] = useState<
    ConfiguredProduct[]
  >([]);

  const { receiverId } = useSelector(
    (state: ApplicationState) => state.longSteelShoppingCart
  );

  const [loading, setLoading] = useState(false);

  const [showToastError, setShowToastError] = useState(false);

  const customerLoading =
    customersState.loading ||
    !!customersState.loadingPurchaseReceivers ||
    !!customersState.loadingProductDescription ||
    !!customersState.loadingBlocks ||
    !!customersState.loadingCustomerById ||
    !!lastOrdersState.loading;

  const loadingPage = customerLoading || loading;

  useEffect(() => {
    if (emitterId && !loadingPage && lastOrdersState.customerId.length !== 0) {
      showOrdersHistoric();
    }
  }, [emitterId, loadingPage, lastOrdersState.loading]);

  const showOrdersHistoric = async () => {
    setLoading(true);
    try {
      const dataOdersHistoric = lastOrdersState.lastOrders;

      if (!dataOdersHistoric.length) {
        showToastMessageError();
        return;
      }

      dataOdersHistoric[0].customerPurchaseOrder;
      dataOdersHistoric[0].salesOrder;
      dataOdersHistoric[0].orderDate;
      dataOdersHistoric[0].items;

      const infoOrdersData = dataOdersHistoric
        .map((order: ILastOrder, index: number) => ({
          key: index,
          invoiceNumber: order.customerPurchaseOrder,
          invoiceSale: order.salesOrder,
          invoiceDate: moment(order.orderDate, 'YYYYMMDD').format('DD/MM/YYYY'),
          originalDate: order.orderDate,
          quantityProduct: order.items.length,
          items: order.items
        }))
        .sort((a: any, b: any) => b.originalDate.localeCompare(a.originalDate));

      setLastOrdersItems(infoOrdersData);
    } catch (error) {
      console.error('Failed to fetch order historic:', error);
    } finally {
      setLoading(false);
    }
  };

  const bottonSheetTagging = (buttonLabel: string) => {
    dispatch(
      sendTagging({
        event: 'click',
        screenName: 'comprar_por_histórico',
        etapa: 'selecionar_emissor_recebedor',
        botao_navegacao: buttonLabel
      })
    );
  };

  const handleProductsConfirmation = async () => {
    setUnavailableProducts([]);
    setLoading(true);
    await updateCartWithConfiguredProducts();
    setLoading(false);
  };

  const updateCartWithConfiguredProducts = async (
    confps?: ConfiguredProduct[],
    cartId?: number | string
  ) => {
    try {
      const products = confps ?? configuredProducts;

      const orderHasBetterPrice = products.some(
        (item) => item?.extension_attributes.has_agreed_price_gerdau
      );
      if (cartQuantity >= 30) {
        dispatch(
          sendTagging({
            event: 'error',
            screenName: commerceScreenName,
            mensagem: 'Seu carrinho atingiu o limite de 30 produtos.'
          })
        );

        dispatch(
          addToast({
            type: EToastTypes.DANGER,
            message: 'Seu carrinho atingiu o limite de 30 produtos.',
            durationInMS: 5000,
            labelActionOne: 'X'
          })
        );
        return;
      }

      const cartSlice = 30 - cartQuantity;
      const itemAdded =
        products.slice(0, cartSlice).length > 0
          ? await addBulkCartItem({
              items: products.slice(0, cartSlice) as any,
              withOptions: false,
              withPrice: false,
              noCheckPrice: cartSlice > 0
            })
          : true;

      if (itemAdded) {
        if (orderHasBetterPrice) {
          dispatch(
            addToast({
              message:
                'Um ou mais produtos tem preço acordado e foram atualizados para as melhores condições.',
              type: EToastTypes.SUCCESS,
              durationInMS: 5000
            })
          );
        }
        return history.push(
          `${ERoutes.PURCHASE}/${EPurchaseRoutes.LONG_STEEL}/commerce/${EOrderSettingsRoutes.SHOPPING_CART}`
        );
      }
    } catch (err) {
      console.error(err);
      throw new Error();
    }
  };

  const goToShoppingCart = async () => {
    bottonSheetTagging('avancar_para_carrinho');
    if (!selectedOrderItem) {
      console.error('Nenhum item foi selecionado.');
      return;
    }
    setLoading(true);

    const cartId = getCartId();

    const productsSku: Array<string> = selectedOrderItem.items.map(
      (item: Item) => item.product.trim()
    );

    const productsNotFound: string[] = [];
    const listOfProductsNotFound: Item[] = [];

    try {
      const magentoProducts = await getMultProducts(
        productsSku,
        ECodeType.SKU,
        emitterId,
        productsSku.length,
        1,
        getCustomer().division
      );

      const configuredProducts: ConfiguredProduct[] = selectedOrderItem.items
        // Filter para remover produtos nao encontrados
        .filter((product: Item) => {
          const productPrice = magentoProducts.find(
            (p) => p.sku === product.product
          );
          if (!productPrice?.price.creditPrice || !productPrice) {
            productsNotFound.push(
              `${product.product} - ${product.productDescription}`
            );
            listOfProductsNotFound.push(product);
          }
          return (
            productPrice &&
            ((!isNaN(Number(productPrice.price.creditPrice)) &&
              Number(productPrice.price.creditPrice) > 0) ||
              (productPrice.price.isAgreementPrice === 'X' &&
                !isNaN(
                  Number(productPrice.price.salesAgreementData.salesAgreement)
                ) &&
                Number(productPrice.price.salesAgreementData.salesAgreement) >
                  0))
          );
        })
        .map((item: Item) => {
          const foundProduct = magentoProducts.find(
            (p) => p.sku === item.product
          );

          const isAgreementPrice = foundProduct?.price.isAgreementPrice === 'X';

          const finalPrice = isAgreementPrice
            ? foundProduct?.price.salesAgreementData.salesAgreement
            : foundProduct?.price.creditPrice;

          const destination = item.destination.length
            ? item.destination
            : isAgreementPrice
            ? foundProduct?.price.salesAgreementData.destination
            : foundProduct?.price.destination;

          const measure = item.requestedMeasureUnit.length
            ? item.requestedMeasureUnit
            : isAgreementPrice
            ? foundProduct?.price.salesAgreementData.agreementUm
            : foundProduct?.price.um;

          const payment = item.paymentTerms.length
            ? item.paymentTerms
            : isAgreementPrice
            ? foundProduct?.price.salesAgreementData.paymentTerms
            : foundProduct?.price.paymentTerms;

          if (!finalPrice || !destination || !measure || !payment) {
            return null;
          }

          return {
            sku: item.product,
            qty: item.requestedQuantity,
            quote_id: cartId,
            price: finalPrice,
            extension_attributes: {
              measure_unity_gerdau: transformMeasureUnit(measure),
              destination_gerdau: destination,
              payment_type_gerdau: payment,
              has_agreed_price_gerdau: isAgreementPrice,
              sap_fields: {
                o_header_sap: [],
                o_item_sap: [],
                o_price_sap: []
              }
            }
          };
        });

      const productsToAdd = configuredProducts.filter((p) => p !== null);
      setConfiguredProducts(productsToAdd);

      if (!productsToAdd.length) {
        dispatch(
          sendTagging({
            event: 'error',
            screenName: commerceScreenName,
            mensagem:
              'Nenhum item foi encontrado para esse pedido. Tente um outro pedido ou fale com um vendedor.'
          })
        );
        return dispatch(
          addToast({
            type: EToastTypes.DANGER,
            message:
              'Nenhum item foi encontrado para esse pedido. Tente um outro pedido ou fale com um vendedor.',
            durationInMS: 5000,
            labelActionOne: 'X'
          })
        );
      }
      if (productsNotFound.length) {
        // mostra o modal e segue o fluxo a partir do modal
        const viewItemListTagging: ITaggingParams = {
          event: 'view_item_list',
          screenName: 'comprar_por_historico',
          ecommerce: {
            screenName: 'comprar_por_historico',
            tipo_compra: 'histórico',
            paginacao: '',
            items: listOfProductsNotFound
              .filter((prd) => prd.product)
              .map((prd) => ({
                screenName: 'comprar_por_historico',
                price: String(prd.price), // sem de-para
                unidade_de_medida: transformMeasureUnit(
                  prd.requestedMeasureUnit
                ),
                item_id: prd.product,
                item_name: prd.productDescription,
                tipo_compra: 'histórico',
                item_category:
                  magentoProducts
                    .find((mgt) => mgt.sku === prd.product)
                    ?.custom_attributes.find(
                      (att) => att.attribute_code === 'descricao_gpm'
                    )?.value ?? '', // sem de-para
                cod_gerdau: prd.product,
                preco_acordado: undefined, // sem de-para
                quantity: String(prd.requestedQuantity)
              }))
          }
        };
        dispatch(sendTagging(viewItemListTagging));
        return setUnavailableProducts(productsNotFound);
      } else {
        // segue o fluxo normal, por isso os produtos são passados por parametro
        await updateCartWithConfiguredProducts(productsToAdd, cartId);
        return;
      }
    } catch (error) {
      console.error('Failed to add items to cart:', error);
    } finally {
      setLoading(false);
    }
  };

  const showToastMessageError = () => {
    setShowToastError(true);
    setTimeout(() => {
      setShowToastError(false);
    }, 5000);
  };

  return (
    <>
      {!isBlockedCustomer && lastOrdersItems.length > 0 && (
        <Container>
          <Title level={3}>Selecione o seu pedido </Title>
          <Table
            columns={columns}
            dataSource={lastOrdersItems}
            rowSelection={{
              type: 'radio',
              onChange: (_, selectedRows: ILastOrderTableDataSource[]) => {
                const [selectedRow] = selectedRows;
                const lastOrder = lastOrdersItems.find(
                  (order) => selectedRow.key === order.key
                );
                if (lastOrder) {
                  dispatch(
                    sendTagging({
                      event: 'selecione_pedido',
                      screenName: 'comprar_por_histórico',
                      ordem_de_venda: lastOrder.invoiceSale,
                      qtde_produto: lastOrder.quantityProduct,
                      data_do_pedido: lastOrder.invoiceDate,
                      identificacao_pedido: lastOrder.invoiceNumber
                    })
                  );
                  setSelectedOrderItem(lastOrder);
                }
              }
            }}
          />
        </Container>
      )}

      <BottomActionBar
        previousBtn={{
          fn: () => {
            bottonSheetTagging('voltar');
            history.goBack();
          },
          name: 'previousBtn',
          text: 'Voltar',
          disabled: loadingPage
        }}
        nextBtn={{
          fn: goToShoppingCart,
          name: 'nextBtn',
          text: 'Avançar para o carrinho',
          disabled:
            loadingPage ||
            !selectedOrderItem ||
            !selectedOrderItem.invoiceSale ||
            !receiverId
        }}
      />
      <LoadingModal
        enabled={loadingPage}
        title="Aguarde alguns instantes"
        message="Carregando os dados..."
      />
      {openBlockedModal && <BlockedModal onCloseModal={onCloseBlockedModal} />}
      <UnavailableProductsModal
        enabled={unavailableProducts.length > 0}
        items={unavailableProducts}
        onConfirm={() => handleProductsConfirmation()}
        onClose={() => {
          return setUnavailableProducts([]);
        }}
      />

      {showToastError && (
        <Toast
          text="Nenhum pedido encontrado para este emissor."
          showIcon={false}
          variant="danger"
          onClose={() => setShowToastError(false)}
        />
      )}
    </>
  );
};
export default LastOrderList;
